import React from 'react';
import NegotiationCutoffTimer from './countdownfornegotiation';

const CountdownRendererfornegotaition = (props) => {
  const indent = props.data;
  if (indent.is_draft === 1) {
    return null;
  }
  return (
    <span style={{ fontSize: '13px', fontWeight: 500 }}>
   <NegotiationCutoffTimer
  biddingWindow={indent.bidding_window}
  negotiationWindow={indent.negotiation_window}
  createDate={indent.indent.create_date}
  indent_id = {indent.indent_id}
  vendorquotes={indent.indent.vendorquotes}
  negotiation_timer_ends={indent.negotiation_timer_ends}
/>

  </span>
  );
};

export default CountdownRendererfornegotaition;